module.exports = require("@tiptap/extension-color");